export default {
  title: '灵武市科技企业孵化器'
}